import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
      const [isDark, setIsDark] = useState(false);

      // On mount, ensure we start with light mode as requested
      useEffect(() => {
            document.documentElement.classList.remove('dark');
            setIsDark(false);
      }, []);

      const toggleTheme = () => {
            setIsDark((prev) => {
                  const newTheme = !prev;
                  if (newTheme) {
                        document.documentElement.classList.add('dark');
                  } else {
                        document.documentElement.classList.remove('dark');
                  }
                  return newTheme;
            });
      };

      return (
            <ThemeContext.Provider value={{ isDark, toggleTheme }}>
                  {children}
            </ThemeContext.Provider>
      );
};

export const useTheme = () => {
      const context = useContext(ThemeContext);
      if (context === undefined) {
            throw new Error('useTheme must be used within a ThemeProvider');
      }
      return context;
};
